<template>
    <div>
        <div class="order-userInfo" v-if="product.product_id == 11">
            <div class="userInfo-wrapper">
                <div class="userInfo-border">
                    <h5>基本设置</h5>
                    <el-row class="userInfo-group special-style">
                        <el-row>
                            <el-col :span="8" class="order-item">学校域名：<span>{{ product.content.cor_domain_url}}</span>
                            </el-col>
                            <el-col :span="8" class="order-item">服务时间：<span>{{new Date(product.content.start_at).toLocaleDateString()}}-{{new Date(product.content.end_at).toLocaleDateString()}}</span>
                            </el-col>
                            <el-col :span="8" class="order-item order-logo-fix"><em>Logo：</em><span
                                    v-if="product.content.fileList.length == 0">暂无</span><span v-else
                                                                                               v-for="logo in product.content.fileList"
                                                                                               :key="logo.uid"><img
                                    :src="product.content.fileList == null ? '暂无' : logo.url"/></span></el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24" class="order-item" style="padding-top:20px;">
                                <label>开通应用：</label>
                                <div class="app-name">
                                    <span v-for="(openApp,index) in open_app" :key="index">
                                        <el-tag style="margin: 0 10px 10px;">{{openApp.app_name}}</el-tag>
                                    </span>
                                </div>
                            </el-col>
                        </el-row>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .el-tag + .el-tag {
        margin-left: 10px;
    }

    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
</style>
<script>
    import CommonService from "~/services/common";
    import OrderService from "~/services/order";

    export default {
        props: {
            product: {
                type: Object
            }
        },
        data() {
            return {
                open_app: [],
                oldProduct: {}
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.getOrder();
                this.getOpenApp(this.id);
            });
            //加载产品列表
        },
        methods: {
            getOpenApp() {
                CommonService.getAllAPP().then(res => {
                    let all = res.data;
                    this.open_app = all.filter(item => {
                        if (typeof this.product.content.open_app != "undefined") {
                            return this.product.content.open_app.includes(item.app_id);
                        }
                    })
                });
            },
            getOrder() {
                OrderService.getDetail(this.product.order_id).then(res => {
                    this.oldProduct = res.data.products.find(i => {
                        return i.product_code == this.product.product_code
                    });
                })
            }
        }

    }
</script>


// WEBPACK FOOTER //
// src/views/order/products/szhxy.vue